import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b38cca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "label"
}, "Nome", -1))
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "label"
}, "Nome de Usuário", -1))
const _hoisted_6 = { class: "control" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "label"
}, "Email", -1))
const _hoisted_9 = { class: "control" }
const _hoisted_10 = { class: "roles-section" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Atribuições")
], -1))
const _hoisted_12 = { class: "check-grid" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "control" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = {
  key: 0,
  class: "tenants-section"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Associar Tenant", -1))
const _hoisted_20 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SelectTenant = _resolveComponent("SelectTenant")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: "Cadastro de Usuário",
    isActive: _ctx.isActive,
    onCloseModalClick: _ctx.closeModalUser
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-user" })
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            id: "name",
            type: "text",
            class: "input",
            placeholder: "Nome",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formUser.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formUser.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            id: "username",
            type: "text",
            class: "input",
            placeholder: "Nome de Usuário",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formUser.username) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formUser.username]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            id: "email",
            type: "email",
            class: "input",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formUser.email) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formUser.email]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          (_ctx.isMaster)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "role",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formRoles) = $event)),
                    value: "MASTER"
                  }, null, 512), [
                    [_vModelRadio, _ctx.formRoles]
                  ]),
                  _createTextVNode(" Master ")
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "role",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formRoles) = $event)),
                value: "ADMIN"
              }, null, 512), [
                [_vModelRadio, _ctx.formRoles]
              ]),
              _createTextVNode(" Administrador ")
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "role",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formRoles) = $event)),
                value: "SUPPORT"
              }, null, 512), [
                [_vModelRadio, _ctx.formRoles]
              ]),
              _createTextVNode(" Suporte ")
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "role",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formRoles) = $event)),
                value: "USER"
              }, null, 512), [
                [_vModelRadio, _ctx.formRoles]
              ]),
              _createTextVNode(" Usuário ")
            ])
          ])
        ])
      ]),
      (_ctx.isMaster)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_SelectTenant, {
              tenant: _ctx.selectedTenant,
              onOnOptionClick: _ctx.selectTenant
            }, null, 8, ["tenant", "onOnOptionClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          class: "button delete-button",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModalUser && _ctx.closeModalUser(...args)))
        }, "Cancelar"),
        _createElementVNode("button", {
          class: "button save-button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveUser(_ctx.formUser, _ctx.formRoles)))
        }, "Salvar")
      ])
    ]),
    _: 1
  }, 8, ["isActive", "onCloseModalClick"]))
}